export class AppSetting {
  "appSettingId": number;
  "appSettingKey": string;
  "appSettingType": string;
  "appSettingValue": string;
  "category": string;
  "name": string;
}
